import React from "react";
import { Breadcrumb, BreadcrumbItem } from "reactstrap";

const ActivityHeader = ({
  history,
  wellness = false,
  activity_name = "",
  handleActivitiesClick
}) => {
  return (
    <section className={`team-act-hero ${wellness ? "wellness" : ""}`}>
      <div className="team-act-content">
        <Breadcrumb>
          <BreadcrumbItem>
            <span
              onClick={() => {
                history.push("/");
                handleActivitiesClick();
              }}
            >
              Home
            </span>
          </BreadcrumbItem>
          <BreadcrumbItem active>
            {activity_name !== "" ? (
              <span onClick={handleActivitiesClick}>Activities</span>
            ) : (
              "Activities"
            )}
          </BreadcrumbItem>
          {activity_name !== "" && (
            <BreadcrumbItem active>{activity_name}</BreadcrumbItem>
          )}
        </Breadcrumb>
        <h4 className="heading">Team Activities</h4>
        <p className="desc">
          Discover team activities to bond, learn, and grow as a team.
        </p>
      </div>
    </section>
  );
};

export default ActivityHeader;
